module.exports = __webpack_public_path__ + "media/images/icon__calendar@2x-90dea906d514ffbee47aa4f77100d163.png";